import { useState, useRef, useEffect } from 'react';
import { Smile } from 'lucide-react';

const EMOJI_GROUPS = {
  'Populares': ['🔥', '⭐', '✨', '💥', '🎉', '🎁', '💰', '💸', '🏷️', '✅', '❤️', '👍', '🚀', '⚡', '🛒', '🛍️'],
  'Descuentos': ['💲', '💵', '🤑', '📉', '🔖', '🎯', '⏰', '⏳', '🔔', '📢', '🆕', '🆓', '💯', '🥇', '🏆', '🎊'],
  'Productos': ['📱', '💻', '🎧', '⌚', '📺', '🎮', '📷', '🔌', '🔋', '🧴', '👕', '👟', '👜', '💄', '🧸', '🍔'],
  'Bancos': ['🏦', '💳', '🪙', '💴', '💶', '💷', '🧾', '📊', '🤝', '🔐', '📈', '💹'],
  'Caras': ['😍', '🤩', '😎', '🥳', '😱', '🤯', '😏', '🙌', '👀', '💪', '🙏', '👏'],
};

const EmojiPickerButton = ({ onSelect, className = '' }) => {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const onClickOutside = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    };
    if (open) document.addEventListener('mousedown', onClickOutside);
    return () => document.removeEventListener('mousedown', onClickOutside);
  }, [open]);

  return (
    <div className={`relative inline-block ${className}`} ref={ref}>
      <button
        type="button"
        onClick={() => setOpen((v) => !v)}
        data-testid="emoji-picker-toggle"
        className="inline-flex items-center gap-1 px-2 py-1 rounded-lg border border-slate-200 bg-white text-slate-600 text-xs font-semibold hover:bg-slate-50 active:scale-95 transition"
        title="Insertar emoji"
      >
        <Smile className="w-4 h-4 text-amber-500" />
        Emoji
      </button>

      {open && (
        <div
          className="absolute right-0 z-50 mt-2 w-72 max-h-72 overflow-y-auto rounded-xl border border-slate-200 bg-white shadow-xl p-3"
          data-testid="emoji-picker-panel"
        >
          {Object.entries(EMOJI_GROUPS).map(([group, emojis]) => (
            <div key={group} className="mb-2 last:mb-0">
              <p className="text-[10px] font-bold uppercase tracking-wide text-slate-400 mb-1">{group}</p>
              <div className="grid grid-cols-8 gap-1">
                {emojis.map((emoji) => (
                  <button
                    key={emoji}
                    type="button"
                    onClick={() => { onSelect(emoji); setOpen(false); }}
                    data-testid={`emoji-option-${emoji}`}
                    className="text-lg leading-none w-8 h-8 flex items-center justify-center rounded-lg hover:bg-slate-100 active:scale-90 transition"
                  >
                    {emoji}
                  </button>
                ))}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default EmojiPickerButton;
